import { useState, useEffect } from 'react';
import { Menu } from './components/Menu';

export function Header() {
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);

  useEffect(() => {
    if (isMobileNavActive) {
      document.body.classList.add('mobile-nav-active');
    } else {
      document.body.classList.remove('mobile-nav-active');
    }
    return () => {
      document.body.classList.remove('mobile-nav-active');
    };
  }, [isMobileNavActive]);

  const toggleMobileNav = () => {
    setIsMobileNavActive((prev) => !prev);
  };

  return (
    <header id="header" className="header d-flex align-items-center sticky-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
        <a href="/" className="logo d-flex align-items-center">
          <img src="/images/logos/logo-blue.svg" alt="Logo Alerta Rolante" />
        </a>
        <nav
          id="navmenu"
          className={`navmenu ${isMobileNavActive ? 'mobile-nav-active' : ''}`}
        >
          <Menu
            onClick={toggleMobileNav}
            isMobileNavActive={isMobileNavActive}
          />
          <button
            className="clean-button d-xl-none"
            onClick={toggleMobileNav}
            aria-label="Toggle navigation"
          >
            <i
              className={`mobile-nav-toggle d-xl-none bit ${isMobileNavActive ? 'bi-x' : 'bi-list'}`}
            />
          </button>
        </nav>
      </div>
    </header>
  );
}
